/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileLinkSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileLinkSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m17.09 7.458-.214-.215a3.128 3.128 0 0 0-4.419 0L10.16 9.542a3.128 3.128 0 0 0 0 4.418l.215.215a3.111 3.111 0 0 0 3.672.546l.027-.028a.658.658 0 0 0 0-.883 1.09 1.09 0 0 0-.39-.334 1.875 1.875 0 0 1-2.425-.184l-.215-.214a1.877 1.877 0 0 1 0-2.652l2.298-2.301a1.877 1.877 0 0 1 2.651 0l.215.215a1.871 1.871 0 0 1 .153 2.465c.05.045.102.088.15.136l.215.215c.179.18.342.375.487.583a3.125 3.125 0 0 0-.121-4.28Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.625 11.826a3.128 3.128 0 0 0-3.662-.555l-.037.037a.625.625 0 0 0 0 .884l.215.215c.05.05.11.09.175.118a1.863 1.863 0 0 1 2.426.184l.215.215a1.877 1.877 0 0 1 0 2.652l-2.298 2.3a1.877 1.877 0 0 1-2.651 0l-.215-.216a1.872 1.872 0 0 1-.153-2.465c-.05-.045-.102-.088-.15-.136l-.215-.215a4.363 4.363 0 0 1-.487-.586 3.125 3.125 0 0 0 .121 4.284l.215.215a3.128 3.128 0 0 0 4.419 0l2.298-2.299a3.128 3.128 0 0 0 0-4.418l-.216-.214Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m16.876 7.243.215.215a3.125 3.125 0 0 1 .9 2.456 3.125 3.125 0 0 0-.9-1.955l-.215-.215a3.129 3.129 0 0 0-4.419 0l-2.298 2.298a3.128 3.128 0 0 0-.903 1.96 3.132 3.132 0 0 1 .903-2.46l2.298-2.299a3.128 3.128 0 0 1 4.419 0Zm-2.682 7.259a.66.66 0 0 0-.12-.692 1.09 1.09 0 0 0-.39-.334 1.876 1.876 0 0 1-2.426-.183l-.215-.215a1.877 1.877 0 0 1-.532-1.076 1.874 1.874 0 0 0 .532 1.576l.215.215a1.875 1.875 0 0 0 2.426.184c.154.078.288.192.39.333a.657.657 0 0 1 .12.192Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.734 9.91a1.872 1.872 0 0 1-.374.895c.05.045.102.088.15.136l.047.047a1.872 1.872 0 0 0 .177-1.079Zm-2.849 1.038c.659.1 1.268.407 1.74.878l.216.214a3.128 3.128 0 0 1 .903 2.46 3.128 3.128 0 0 0-.903-1.96l-.216-.214a3.128 3.128 0 0 0-3.662-.554l-.037.036a.625.625 0 0 0-.13.192.625.625 0 0 1 .13-.692l.037-.037a3.128 3.128 0 0 1 1.922-.323Zm1.603 3.552c-.054.405-.24.783-.531 1.075l-2.298 2.3a1.877 1.877 0 0 1-2.651 0l-.215-.215a1.871 1.871 0 0 1-.527-1.069 1.869 1.869 0 0 0 .527 1.57l.215.214a1.877 1.877 0 0 0 2.651 0l2.298-2.3a1.877 1.877 0 0 0 .531-1.575Zm-6.045 1.012c.054-.111.12-.217.197-.317l-.024-.022-.026-.023-.003-.002a2.19 2.19 0 0 1-.097-.089l-.215-.215a4.364 4.364 0 0 1-.487-.586 3.125 3.125 0 0 0-.78 2.328 3.125 3.125 0 0 1 .78-1.828c.145.21.308.406.487.587l.168.167Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileLinkSmall
};
